import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Weight } from "@faire/web/slate/Font/utils";
import { Spacer } from "@faire/web/slate/spacing";
import { TypographyStyles } from "@faire/web/slate/Typography";
import { Link as RouterLink } from "@faire/web/ui/LinkAnchor";
import * as React from "react";
import styled from "styled-components";
export var PopularArticlesList = function PopularArticlesList(_ref) {
  var articles = _ref.articles,
    navigatedFrom = _ref.navigatedFrom;
  return /*#__PURE__*/React.createElement(React.Fragment, null, articles === null || articles === void 0 ? void 0 : articles.map(function (guide) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: guide.id
    }, /*#__PURE__*/React.createElement(Link, {
      to: {
        pathname: articlePage("".concat(guide.id)),
        state: {
          navigatedFrom: navigatedFrom,
          pageFrom: location.pathname,
          articleTitle: guide.name
        }
      }
    }, guide.name), /*#__PURE__*/React.createElement(Spacer, {
      height: "2x"
    }));
  }));
};
var Link = styled(RouterLink).withConfig({
  displayName: "PopularArticlesList__Link"
})(["", " &:hover{font-weight:", ";}-webkit-tap-highlight-color:rgba(0,0,0,0.05);"], TypographyStyles({}), Weight.medium);